<ng-container [formGroup]="formGroup">

  <div class="page-content-section options-panel attribute-types">
    <fieldset>
      <legend>{{'Attribute Type' | translate}}</legend>
      <nz-radio-group formControlName="Type" id="Type" [nzDisabled]="mode === 'edit'">
        <ng-container *ngFor="let option of types">
          <label class="option-label" nz-radio-button [nzValue]="option.Code">
            <i [class]="'fa-light fa-' + option.Icon"></i>
            <br />
            {{ option.Name }}
          </label>
        </ng-container>
      </nz-radio-group>
    </fieldset>
  </div>
  <ng-container *ngIf="formGroup.value['Type'] == '6' || formGroup.value['Type'] == '7'">
    <app-attribute-options 
    [buttonLabel]="'Add New Option'"
    [sectionTitle]="'Attribute Options'"
    
    [formGroup]="formGroup" [record]="record" [listOfOptions]="listOfOptions"
      (optionsChanged)="optionsChanged.emit($event)"></app-attribute-options>
  </ng-container>
</ng-container>
